import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import Button from '../../button/Button';

import { MEASURE_BY_SKILL_NAME } from '../../../constants/assessments';
import { usePopupContext } from '../../../common/contexts/PopupContext';

const SelectableGradeForm = ({ studentId, form, nextFormUidsByMeasures, skillName }) => {
    const {
        actions: { showPMFormSelectionPopup },
    } = usePopupContext();

    const label = get(form, 'label', '');
    if (label === '') {
        return <span />;
    }

    const onClick = () => {
        const grade = get(form, 'grade', '');
        const measureName = MEASURE_BY_SKILL_NAME[skillName];
        const initialFormUidsByGrade = nextFormUidsByMeasures?.[measureName];
        showPMFormSelectionPopup({
            studentId,
            skillName,
            measureName,
            grade,
            initialFormUidsByGrade,
        });
    };
    return (
        <div className='dashboard-grade-form'>
            <Button onClick={onClick}>{label}</Button>
        </div>
    );
};

SelectableGradeForm.propTypes = {
    studentId: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    nextFormUidsByMeasures: PropTypes.object.isRequired,
    skillName: PropTypes.string.isRequired,
};

export default SelectableGradeForm;
